import { updateItemInCollection } from "directus/src/operations";

export async function updateJob({ id, item }) {
  try {
    const query = {
      fields: [
        "*",
        {
          coordinator: [
            "id",
            "first_name",
            "last_name",
            "avatar",
            "title",
            "department.name",
            "user.role.name",
          ],
        },
      ],
    };

    const data = await updateItemInCollection("jobs", id, item, query);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
